import { http } from '../request'
import type { PaginationData } from '../request'
import type {
    GunSkin,
    GunSkinCreateRequest,
    GunSkinUpdateRequest,
    GunSkinCreateResponse,
    GunSkinUpdateResponse
} from '../types/gunSkins'

/**
 * 枪皮相关 API
 */
export const gunSkinsApi = {
    /**
     * 获取所有枪皮数据（分页格式）
     * GET /api/gun-skins/
     */
    getAllGunSkins(params?: { page?: number; size?: number }): Promise<PaginationData<GunSkin>> {
        return http.get<PaginationData<GunSkin>>('/api/gun-skins/', { params })
    },

    /**
     * 创建枪皮
     * POST /api/gun-skins/
     */
    createGunSkin(data: GunSkinCreateRequest): Promise<GunSkinCreateResponse> {
        return http.post<GunSkinCreateResponse>('/api/gun-skins/', data)
    },

    /**
     * 更新枪皮
     * PUT /api/gun-skins/{id}/
     */
    updateGunSkin(id: number, data: GunSkinUpdateRequest): Promise<GunSkinUpdateResponse> {
        return http.put<GunSkinUpdateResponse>(`/api/gun-skins/${id}/`, data)
    },

    /**
     * 删除枪皮
     * DELETE /api/gun-skins/{id}/
     */
    deleteGunSkin(id: number): Promise<void> {
        return http.delete<void>(`/api/gun-skins/${id}/`)
    }
}

export default gunSkinsApi
